
import React from 'react';
import { Button } from '@/components/ui/button';
import { Rocket } from 'lucide-react';
import { Link } from 'react-router-dom';

const BetaProgramCTA: React.FC = () => {
  return (
    <section className="py-16 px-6 md:px-10 bg-white dark:bg-gray-900">
      <div className="container mx-auto animate-fade-in-up opacity-0" style={{animationDelay: "200ms", animationFillMode: "forwards"}}>
        <div className="max-w-6xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-xl overflow-hidden">
          <div className="flex flex-col md:flex-row">
            {/* Left content */}
            <div className="p-8 md:p-12 md:w-3/5">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-indigo-100 text-indigo-700 mb-6 animate-fade-in-up opacity-0" style={{animationDelay: "300ms", animationFillMode: "forwards"}}>
                <Rocket className="h-5 w-5 mr-2" />
                <span className="text-sm font-medium">Beta Program</span>
              </div>
              
              <h3 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white animate-fade-in-up opacity-0" style={{animationDelay: "400ms", animationFillMode: "forwards"}}>
                Join Our AI Early Access Program
              </h3>
              
              <p className="text-gray-700 dark:text-gray-300 mb-8 animate-fade-in-up opacity-0" style={{animationDelay: "500ms", animationFillMode: "forwards"}}>
                Be among the first to experience our cutting-edge AI solutions. 
                Beta users receive exclusive benefits:
              </p>
              
              <ul className="space-y-4 mb-8">
                {[
                  'Priority access to new AI features',
                  'Reduced pricing (up to 40% off)',
                  'Direct input on product development',
                  'Dedicated support channel'
                ].map((benefit, i) => (
                  <li key={i} className="flex items-start animate-fade-in-up opacity-0" style={{animationDelay: `${600 + (i * 100)}ms`, animationFillMode: "forwards"}}>
                    <span className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mr-3 mt-0.5">
                      <svg className="h-4 w-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                    <span className="text-gray-700 dark:text-gray-300">{benefit}</span>
                  </li>
                ))}
              </ul>
              
              <Button 
                className="bg-indigo-600 hover:bg-indigo-700 text-white group animate-fade-in-up opacity-0"
                size="lg"
                asChild
                style={{animationDelay: "1000ms", animationFillMode: "forwards"}}
              >
                <Link to="/beta-signup" target="_blank" rel="noopener noreferrer">
                  Apply for Early Access
                  <svg className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
              </Button>
            </div>
            
            {/* Right image/pattern */}
            <div className="md:w-2/5 bg-indigo-600 flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 opacity-20">
                <div className="absolute top-0 left-0 w-full h-full">
                  {[...Array(5)].map((_, i) => (
                    <div 
                      key={i}
                      className="absolute rounded-full bg-white/30"
                      style={{
                        width: `${Math.random() * 100 + 50}px`,
                        height: `${Math.random() * 100 + 50}px`,
                        top: `${Math.random() * 100}%`,
                        left: `${Math.random() * 100}%`,
                        opacity: Math.random() * 0.5 + 0.1,
                        transform: `scale(${Math.random() * 0.5 + 0.5})`,
                      }}
                    />
                  ))}
                </div>
              </div>
              <div className="relative z-10 p-8 text-center">
                <div className="rounded-full bg-white/10 p-4 inline-flex mb-4 animate-float">
                  <Rocket className="h-16 w-16 text-white" />
                </div>
                <h4 className="text-2xl font-bold text-white mb-4 animate-fade-in-up opacity-0" style={{animationDelay: "300ms", animationFillMode: "forwards"}}>
                  Limited Spots Available
                </h4>
                <p className="text-white/80 animate-fade-in-up opacity-0" style={{animationDelay: "400ms", animationFillMode: "forwards"}}>
                  Our beta program is accepting new participants until June 30
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetaProgramCTA;
